// A Skills Hub class card can link to lpExternalUrl. The grant-funded site must
// not funnel visitors to commercial, off-domain destinations, so any external
// URL that points off sols.foundation is treated as offsite and filtered out
// (both from the rendered list and from the data/schema passed to the page).
export const isOffsiteUrl = (url?: string): boolean => {
  if (!url || !/^https?:\/\//i.test(url)) return false;
  try {
    return !new URL(url).hostname.toLowerCase().endsWith("sols.foundation");
  } catch {
    return true;
  }
};
